import React from 'react';

import Stack from '@mui/material/Stack';

import GuideInfoBox from '../components/GuideInfoBox';
import GuidePageLayout from '../components/GuidePageLayout';
import GuideSection from '../components/GuideSection';
import GuideStepList from '../components/GuideStepList';
import GuideTable from '../components/GuideTable';

const GuideTrainingAdmin: React.FC = () => {
  return (
    <GuidePageLayout
      title="他ユーザーのワークスペースを閲覧する（管理者）"
      description="ADMIN / DEVELOPER が、指定したユーザーのワークスペースを閲覧・操作します。"
      breadcrumbs={[
        { label: 'ワークスペース（コードエディタ）概要', path: '/guide/training/overview' },
      ]}
    >
      <GuideSection title="アクセス権限">
        <GuideTable
          headers={['ロール', 'アクセス可否']}
          rows={[
            ['管理者 (ADMIN)', '利用可能'],
            ['開発者 (DEVELOPER)', '利用可能'],
            ['その他のロール', '利用不可'],
          ]}
        />
      </GuideSection>

      <GuideSection title="他ユーザーのワークスペースを開く">
        <GuideStepList
          steps={[
            { label: 'コードエディタ画面（ワークスペース）を開く' },
            {
              label: 'アクティビティバー（最左）下部のユーザーアイコンを押す',
              description: 'ADMIN / DEVELOPER の場合のみ表示されます。',
            },
            {
              label: '表示されたメニューから対象のユーザー名を選択する',
              description:
                '全ユーザーの名前が一覧表示されます。「マイワークスペース」を選ぶと自分のワークスペースに戻れます。',
            },
            { label: '管理者用APIにより、選択したユーザーのワークスペースが表示される' },
          ]}
        />
      </GuideSection>

      <GuideSection title="編集可否の切り替え">
        <GuideStepList
          steps={[
            {
              label: '他ユーザーのワークスペースはデフォルトで「閲覧のみ」',
              description: 'エディタは編集不可、作成・削除・保存などの操作もできません。',
            },
            {
              label: 'アクティビティバー下部の編集ロックアイコンを押して編集可能に切り替える',
              description:
                '鍵付き（EditOff）アイコンで「閲覧のみ」、編集（Edit）アイコンで「編集可能」を表します。押すたびに切り替わります。',
            },
            { label: '編集可能にすると、自分のワークスペースと同様に操作できる' },
          ]}
        />
        <Stack spacing={1} sx={{ mt: 2 }}>
          <GuideInfoBox type="warning">
            他ユーザーのファイルを誤って変更しないよう、必要な時のみ編集可能に切り替えてください。
          </GuideInfoBox>
        </Stack>
      </GuideSection>
    </GuidePageLayout>
  );
};

export default GuideTrainingAdmin;
